module.exports = __webpack_public_path__ + "media/images/redesign-images/home-new/home-slides/prod-01-746c35fc4a2357d39fbcac0cb2b1eba8.jpg";